function formatPhoneNumber(phoneNumber) {
  return phoneNumber ? `0${phoneNumber.slice(4, 6)}-${phoneNumber.slice(-7)}` : null;
}
function validatePhoneNumber(phoneNumber) {
  return phoneNumber.length === 10;
}

export default {
  formatPhoneNumber,
  validatePhoneNumber,
};
